export const PlusConfig = {
    API: {
		    ENDPOINT: 'https://sec-audi.sociedaddesegurosdevida.cr',
        APIKEY: 'dWq3G51N2B54qfz12nhy75T9q4q1hJERz8=',
        IS_DMZ: true
    },
    FORMS: {
        ENDPOINT: 'forms.sigma-web.net',
        DB: 'SIGMA',
        DEFAULT_FORM: 'SIGMA'
    },
    UNL: {
        ENDPOINT: 'https://unl.sigma-web.net:8000'
    }
}
